import Head from "next/head";
import { AccountLinkProvider } from "@medbillai/app/lib/accounts-link/accountLinkProvider";
import { ClosableAccountLinkLayout } from "@medbillai/app/screens/accounts-link/layout.web";
import { UnsupportedPlanScreen } from "@medbillai/app/screens/accounts-link/unsupported-plan";
import { AuthGate } from "../../utils/AuthGate";
import { SlidingLayout } from "../../utils/transition/SlidingLayout";
import type { NextPageWithLayout } from "../_app";
export const Page: NextPageWithLayout = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="unsupported-plan.tsx">
        <title>Unsupported Plan</title>
      </Head>
      <UnsupportedPlanScreen data-sentry-element="UnsupportedPlanScreen" data-sentry-source-file="unsupported-plan.tsx" />
    </>;
};
Page.getLayout = page => <AuthGate>
    <ClosableAccountLinkLayout>
      <AccountLinkProvider>
        <SlidingLayout>{page}</SlidingLayout>
      </AccountLinkProvider>
    </ClosableAccountLinkLayout>
  </AuthGate>;
export default Page;